import React from 'react';

export const Blockquote: React.FC = ({ children }) => (
  <div className="shadow-2xl p-6 my-12 flex">
    <span className="text-8xl -mt-2 pr-6 text-accent">"</span>
    <span className="-mb-4">{children}</span>
  </div>
);
